import { WorkCenter } from '../../shopfloor/workcenters/work-center'
import { Interval } from '@elderbyte/ngx-starter'
import { ControlTerminalMode } from '../../terminals/control-terminal-mode'
import { Instant } from '@js-joda/core'

export class ProductionListContext {
  public static preview(
    workCenter: WorkCenter,
    scheduleInterval: Interval,
    prodListConfId: string
  ): ProductionListContext {
    return new ProductionListContext(
      ControlTerminalMode.PREVIEW,
      workCenter,
      prodListConfId,
      scheduleInterval,
      null
    )
  }

  public static live(
    workCenter: WorkCenter,
    timestamp: Instant,
    prodListConfId: string
  ): ProductionListContext {
    return new ProductionListContext(
      ControlTerminalMode.LIVE,
      workCenter,
      prodListConfId,
      null,
      timestamp
    )
  }

  constructor(
    public mode: ControlTerminalMode,
    public workCenter: WorkCenter,
    public prodListConfId: string,
    public scheduleInterval?: Interval,
    public timestamp?: Instant
  ) {}

  public equals(context: ProductionListContext): boolean {
    return (
      !!context &&
      this.workCenter === context.workCenter &&
      this.mode === context.mode &&
      this.scheduleInterval === context.scheduleInterval &&
      this.timestamp === context.timestamp &&
      this.prodListConfId === context.prodListConfId
    )
  }
}
